import React, { Component } from 'react'
import { getAbsolutePath } from '../../../global/environments/path.js'
import { sanitizeUrl } from '../../../global/formatters/sanitize-url.js'
import {
  isInstitutionalLoggedIn,
  logoutInstitutional,
  accessStorage,
} from '../../../spa/components/institutional/common/institutionalConfig.js'

class AuthenticatedDropdownInstitutional extends Component {
  constructor(props) {
    super(props)
    this.state = {
      expanded: false,
    }
  }

  onButtonClick = () => {
    this.setState({ expanded: !this.state.expanded })
  }

  render() {
    const userData = accessStorage.getUserInfo()
    return isInstitutionalLoggedIn() ? (
      <div
        className={`u-hidden u-sm-block CtiDropdown ${
          this.state.expanded ? 'is-expanded' : ''
        }`}
      >
        <button
          onClick={this.onButtonClick}
          className="CtiDropdown-toggle Button u-textTruncate u-padding2gu u-paddingRight4gu u-textSizeMsrp1 u-textSecondary u-textColorBrand u-flex u-flexJustifyCenter u-flexAlignItemsCenter"
          type="button"
          id="secondary-dropdown"
          aria-haspopup={this.state.expanded}
          aria-expanded={this.state.expanded}
        >
          {userData?.fullName}
        </button>
        <ul
          className="CtiDropdown-menu u-bgColorWhite u-borderColorNeutralLight u-borderBottom u-borderTop u-borderLeft u-borderRight u-posAbsolute u-paddingBottom1gu"
          aria-labelledby="secondary-dropdown"
        >
          <li className="u-textSizeMsrp1 u-textSecondary CtiDropdown-item">
            <a
              className="CtiDropdown-link u-block u-padding2gu u-textNoWrap"
              href={sanitizeUrl(
                `${getAbsolutePath(true)}/secure/change-password`
              )}
            >
              Change Password
            </a>
          </li>

          <li className="u-textSizeMsrp1 u-textSecondary CtiDropdown-item">
            <a
              className="CtiDropdown-link u-block u-padding2gu u-textNoWrap"
              href={sanitizeUrl(`${getAbsolutePath(true)}/secure/your-reports`)}
            >
              Your Reports
            </a>
          </li>

          <li className="UtilityNavigation-listItem u-inlineBlock u-marginRight1gu u-textSizeMsr u-marginLeft3gu u-sm-marginLeft0">
            <a
              className="CtiDropdown-link u-block u-padding2gu u-textNoWrap"
              href={sanitizeUrl(`${getAbsolutePath(true)}/logout`)}
              onClick={() => logoutInstitutional()}
            >
              Log Out
            </a>
          </li>
        </ul>
      </div>
    ) : (
      <li className="UtilityNavigation-listItem u-hidden u-sm-inlineBlock u-marginLeft1gu">
        <a
          className="UtilityNavigation-action u-textNoWrap Button Button--secondary"
          href={sanitizeUrl(`${getAbsolutePath(true)}/login`)}
        >
          Log In
        </a>
      </li>
    )
  }
}

export default AuthenticatedDropdownInstitutional
